export const GET_TIP_DATA ="GET_TIP_DATA";
export const GET_TIP_DATA_SUCCESS ="GET_TIP_DATA_SUCCESS";
export const GET_SCORECARD_REPORT ="GET_SCORECARD_REPORT";
export const GET_SCORECARD_REPORT_SUCCESS="GET_SCORECARD_REPORT_SUCCESS";
export const GET_SCORE_SUCCESS="GET_SCORE_SUCCESS";
export const GET_SCORE="GET_SCORE";
export const GET_FLIGHTS_SUCCESS="GET_FLIGHTS_SUCCESS";
export const GET_FLIGHTS_ERROR="GET_FLIGHTS_ERROR";
export const GET_FLIGHTS_DETAILS="GET_FLIGHTS_DETAILS";